import { Suspense } from "react";
import { lazy } from "react";


import * as Sentry from "@sentry/react";

import { NodeDiagramProvider } from "@/components/Procedures/NodeDiagram/Context/NodeDiagramContext";

import PageError from "@/helpers/components/Errors/PageError";
import { Spinner } from "@/helpers/components/Spinner";
import { QueryErrorResetBoundary } from "@tanstack/react-query";

const NodeDiagramContainer = lazy(
	() =>
		import(
			"@/components/Procedures/NodeDiagram/Containers/NodeDiagramContainer"
		),
);

export const NodeDiagramPage = () => {
	return (
		<NodeDiagramProvider>
			<QueryErrorResetBoundary>
				{({ reset }) => (
					<Sentry.ErrorBoundary
						onReset={reset}
						fallback={({ error, componentStack, resetError }) => (
							<PageError
								error={error}
								reset={resetError}
								componentStack={componentStack}
							/>
						)}
					>
						<Suspense fallback={<Spinner text="Loading" />}>
							<NodeDiagramContainer />
						</Suspense>
					</Sentry.ErrorBoundary>
				)}
			</QueryErrorResetBoundary>
		</NodeDiagramProvider>
	);
};
